export default "__VITE_ASSET__BcaqjfdE__"